import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { Environment } from '../../../../app/models/environment';
import { EnvironmentService } from '../../../../app/api/api/environment.service';

@Injectable({
  providedIn: 'root'
})

export class PersonalizationsService implements OnDestroy {

  /**
  * Get the configuration json
  */
  envSubscription: Subscription;

  environment: Environment;

  /**
  * Parameter un charge of detect pro flow
  */
  hasFinishProActive: boolean = false;

  /**
  * Get the configuration json
  */
  env: Promise<Environment>;

  private dataSource: BehaviorSubject<Environment>;

  constructor(
    private _environment: EnvironmentService
  ) { }

  async getEnvconfig(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.envSubscription = this._environment.environmentGetListCustomCircuit('').subscribe(
        data => {
          this.environment = data;
          // this.environment.features.singlePage = false;
          this.dataSource = new BehaviorSubject<Environment>(this.environment);
          resolve(true);
        }, error => {
          console.log('error', error);
          this.envSubscription.unsubscribe();
          reject(false);
        }
      );
    })
  }


  get sendEnv(): Environment | undefined {
    if (this.dataSource) {
      return this.dataSource.getValue();
    }
    return undefined;
  }

  ngOnDestroy(): void {
    this.envSubscription.unsubscribe();
  }

}
